// --- API Hooks ---
import {
  useGetCartQuery,
  useAddToCartMutation,
  useUpdateCartItemMutation,
  useRemoveCartItemMutation,
  useClearCartMutation,
  useApplyCouponMutation,
  useRemoveCouponMutation,
  useSelectShippingRateMutation,
  useUpdateCustomerMutation,
} from "../templates/ecommerce/cart/api/cartApi";

// --- Custom Logic Hooks ---
import { useApplyCoupon } from "../templates/ecommerce/cart/hooks/useApplyCoupon";
import { useClearCart } from "../templates/ecommerce/cart/hooks/useClearCart";
import { useMoveCartItemToWishlist } from "../templates/ecommerce/cart/hooks/useMoveCartItemToWishlist";
import { useProductAddToCart } from "../templates/ecommerce/cart/hooks/useProductAddToCart";
import { useRemoveCartItemFromCart } from "../templates/ecommerce/cart/hooks/useRemoveCartItemFromCart";
import { useRemoveCoupon } from "../templates/ecommerce/cart/hooks/useRemoveCoupon";
import { useSelectShippingRate } from "../templates/ecommerce/cart/hooks/useSelectShippingRate";
import { useUpdateCartItemQuantity } from "../templates/ecommerce/cart/hooks/useUpdateCartItemQuantity";
import { useUpdateCustomer } from "../templates/ecommerce/cart/hooks/useUpdateCustomer";

// --- Components ---
import CartPage from "../templates/ecommerce/cart/components/CartPage/CartPage";
import CartPanel from "../templates/ecommerce/cart/components/CartPanel/CartPanel";
import CartTotals from "../templates/ecommerce/cart/components/common/CartTotals";
import QuantityControl from "../templates/ecommerce/cart/components/common/QuantityControl";
import FirstPurchaseBanner from "../templates/ecommerce/cart/components/common/FirstPurchaseBanner";
import FreeShippingProgressBar from "../templates/ecommerce/cart/components/common/FreeShippingProgressBar";

// --- Selectors ---
import { selectCartCount } from "../templates/ecommerce/cart/cartSelectors";

export const cart = {
  // 1. API Data Fetching
  api: {
    useGetCartQuery,
    useAddToCartMutation,
    useUpdateCartItemMutation,
    useRemoveCartItemMutation,
    useClearCartMutation,
    useApplyCouponMutation,
    useRemoveCouponMutation,
    useSelectShippingRateMutation,
    useUpdateCustomerMutation,
  },

  // 2. Custom Business Logic Hooks
  hooks: {
    useApplyCoupon,
    useClearCart,
    useMoveCartItemToWishlist,
    useProductAddToCart,
    useRemoveCartItemFromCart,
    useRemoveCoupon,
    useSelectShippingRate,
    useUpdateCartItemQuantity,
    useUpdateCustomer,
  },

  // 3. UI Components
  components: {
    CartPage,
    CartPanel,
    CartTotals,
    QuantityControl,
    FirstPurchaseBanner,
    FreeShippingProgressBar,
  },

  // 4. Selectors
  selectors: {
    selectCartCount,
  },
};
